import Image from "next/image";
import { gql } from "@apollo/client";
import Box from "@mui/material/Box";
import { ASSESSMENT, IMPURITY } from "@/utils/features/constants";
import { SC } from "./graphql/query";
import { useContainer } from "./hooks/useContainer";
import styles from "./styles.module.css";
import { Footer, SideBarItems } from "./uis";
import { ASSESSMENT_ITEMS } from "./utils/createAssessmentItems";
import { impurityItems } from "./utils/impurityItems";

/** @public */
export const SIDE_BAR_FACTORY_FIELDS = gql`
  fragment SideBar_FactoryFields on Factory {
    features
    unloadingDockPattern
  }
`;

/** @public */
export const SIDE_BAR_UNLOADING_DOCK_FIELDS = gql`
  fragment SideBar_UnloadingDockFields on UnloadingDock {
    name
  }
`;
export const SideBarIcon = SC<{
  isSmall?: boolean;
}>(({
  me,
  isSmall = false
}) => {
  const {
    currentPath,
    open,
    setOpen,
    isSamlUser,
    remoteAssessmentVisible
  } = useContainer();
  return <Box position="relative">
      <Box width={isSmall && !open ? "36px" : "96px"} height={isSmall && !open ? "32px" : "64px"} margin="8px" mb="0px" display="flex" justifyContent="center" className={styles.sidebarContainer} onClick={() => setOpen(!open)} sx={{
      transition: isSmall && !open ? `width 0.5s ease 0.3s, height 0.5s ease 0.3s` : "none"
    }}>
        <Box className={styles.sidebarIcon} sx={{
        borderRadius: open ? "16px 16px 0 0" : isSmall ? "0 0 16px 0" : "16px",
        transition: isSmall && !open ? `border-radius 0.5s ease 0.3s` : open || isSmall ? "border-radius 0s" : "border-radius 0.5s",
        boxShadow: open ? "none" : "0 1px 3px 0 rgb(28 46 46 / 12%), 0 1px 2px 0 rgb(28 46 46 / 4%)",
        padding: isSmall ? "4px" : "16px"
      }}>
          <Box width={isSmall && !open ? "20px" : "48px"} height={isSmall && !open ? "20px" : "48px"} sx={{
          transition: isSmall && !open ? "width 0.5s ease 0.3s, height 0.5s ease 0.3s" : "none"
        }}>
            <Image src="/assets/eversteel/logo.png" alt="logo-Eversteel" width={48} height={48} style={{
            objectFit: "contain"
          }} />
          </Box>
        </Box>
      </Box>

      <Box data-testid="overflow-container" display="flex" flexDirection="column" justifyContent="space-between" width="96px" margin="8px" mt="0px" position="absolute" top={isSmall ? "64px" : "72px"} overflow="hidden" className={styles.expandedContainer} sx={{
      ...(open ? {
        // 81px はヘッダー内のサイドバー開始位置までのオフセット。加えて上部の
        // sticky バナー (モード帯/障害通知/復旧) 分を差し引き、展開時の下端
        // (フッター) がビューポート内に収まるようにする
        height: "calc(100vh - 81px - var(--top-stack-height, 0px))"
      } : {
        height: 0
      })
    }}>
        <Box className={styles.contentWrapper}>
          {me.features.includes(ASSESSMENT) && <Box pt="16px">
              <Box display="flex" flexDirection="column" gap="8px">
                <SideBarItems list={ASSESSMENT_ITEMS} currentPath={currentPath} />
                {me.features.includes("DirectAsset") && remoteAssessmentVisible && <SideBarItems list={[{
              icon: "remoteAssessment",
              to: "/remote-assessment"
            }]} currentPath={currentPath} />}
                {me.features.includes(IMPURITY) && <SideBarItems list={impurityItems} currentPath={currentPath} />}
              </Box>
            </Box>}
          {isSamlUser && <Box pt={me.features.includes(ASSESSMENT) ? "8px" : "16px"}>
              <SideBarItems list={[{
            icon: "inspector",
            customLabel: "Admin",
            to: "/admin"
          }]} currentPath={currentPath} />
            </Box>}
        </Box>
        <Footer unloadingDockPattern={me.unloadingDockPattern} />
      </Box>
    </Box>;
});